export default "__VITE_ASSET__C7FnQO71__"